//libs
import React, { Component } from 'react';
import { connect } from 'react-redux';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import ReactTable from 'react-table';
import axios from 'axios/index';
import FileDownload from 'js-file-download';
import DatePicker from 'react-datepicker';

//components
import PageWithSidebar from '../Layouts/PageWithSidebar';
import Loading from '../UI_Elements/Loading';

//config and heloers
import { get } from '../../actions/reports';
import { isAdmin } from '../../helpers';
import Config from '../../config';

moment.tz.setDefault('Europe/Stockholm');
moment.locale('sv');

class Reports extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentReport: '',
      currentReportsData: [],
    };

    this.printExcel = this.printExcel.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
  }

  componentWillReceiveProps(props) {
    if (!props.submitting && props.reportsData.length > 0) {
      this.setState({
        currentReportsData: props.reportsData,
      });
    }
  }

  showReport(e) {
    let action = typeof e.target === 'undefined' ? e : e.target.getAttribute('data-report-id');

    this.setState({ currentReport: action, currentReportsData: [] }, () => {
      switch (action) {
        case 'stationInventory':
          this.props.get(action, '');
          break;

        case 'returnStation':
        case 'movedBetweenStations':
        case 'shippedFromWheelSupplier':
        case 'recievedAtWarehouse':
          if (this.state.fromDate && this.state.toDate) {
            let dates = {
              fromDate: encodeURIComponent(moment(this.state.fromDate).format()),
              toDate: encodeURIComponent(moment(this.state.toDate).format()),
            };

            // Create query string from dates
            let queryString =
              '?' +
              Object.keys(dates)
                .map((key) => {
                  return key + '=' + dates[key];
                })
                .join('&');

            this.props.get(action, queryString);
          }

          break;

        default:
          this.props.get(action, '?wheelStatus=3&wheelStatus=4');
          break;
      }
    });
  }

  handleDateChange(dateName, dateValue) {
    this.setState(
      {
        [dateName]: dateValue,
      },
      () => {
        if (this.state.fromDate && this.state.toDate) {
          this.showReport(this.state.currentReport);
        }
      }
    );
  }

  getColumnWidth(fieldName) {
    switch (fieldName) {
      case 'carModel':
        return 220;
      case 'fromLocationRetailerId':
      case 'toLocationRetailerId':
      case 'wheelOnCarType':
      case 'createdDate':
      case 'receivedDate':
      case 'shippedDate':
      case 'requestedDeliveryDate':
      case 'date':
        return 140;
      case 'itemNumber':
      case 'fromLocation':
      case 'orderLineNumber':
        return 90;
      case 'waggonNo':
      case 'regNo':
      case 'regno':
      case 'wheelNotOnCar':
      case 'wheelOnCar':
      case 'retailerId':
      case 'quantity':
      case 'orderId':
      case 'toLocation':
      case 'returnInventLocationId':
      case 'wheelType':
        return 60;
      default:
        return 0;
    }
  }

  getAutoColumns(data) {
    let keys = Object.keys(data);

    let x = null;
    let columns = [];
    let columnSettings = null;
    let columnWidth = 0;
    for (x in keys) {
      columnSettings = {
        Header: keys[x],
        accessor: keys[x],
        resizable: false,
      };
      columnWidth = this.getColumnWidth(keys[x]);
      if (columnWidth > 0) {
        columnSettings.width = columnWidth;
      }
      columns.push(columnSettings);
    }

    return columns;
  }

  printExcel(e) {
    e.preventDefault();

    let data = {};
    if (this.state.currentReport !== 'returnStation') {
      data = {
        reportType: this.state.currentReport,
        wheelStatuses: [3, 4],
      };
    } else {
      data = {
        reportType: this.state.currentReport,
      };
    }

    const haveDatePicker = [
      'movedBetweenStations',
      'shippedFromWheelSupplier',
      'recievedAtWarehouse',
      'returnStation',
    ];

    let filename =
      this.state.currentReport.toLocaleLowerCase() + '_' + moment().format('YYYY_MM_DD') + '.xlsx';

    if (haveDatePicker.includes(this.state.currentReport)) {
      data.fromDate = moment(this.state.fromDate).format();
      data.toDate = moment(this.state.toDate).format();
    }

    // if (stockInventory) {
    //     // skicka bara 3 och 4 och reporttype
    // }

    axios
      .post(Config.api.getDomain() + 'report/reportExcelExport', data, {
        headers: Config.api.getConfig().headers,
        responseType: 'blob',
      })
      .then((response) => {
        FileDownload(response.data, filename);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  handleDateChangeRaw(e) {
    e.preventDefault();
  }

  render() {
    // Station inventory - Station - Lager status
    // Moved between stations - Skickat mellan Stationer
    // Stock inventory - Centrallager - Lager status
    // Shipped from wheel supplier - Skickat från Good year
    // Recieved at warehouse - Mottaget på Centrallager
    // Blocked cars - Reserverade bilar
    // Mounted on car - Monterat på bil

    const rerportTypes = [
      {
        id: 'stationInventory',
        title: 'Station - Lagerstatus',
      },
      {
        id: 'movedBetweenStations',
        title: 'Skickat mellan Stationer',
      },
      {
        id: 'shippedFromWheelSupplier',
        title: 'Skickat från däckleverantör/centrallager',
      },
      {
        id: 'recievedAtWarehouse',
        title: 'Mottaget på Centrallager',
      },
      {
        id: 'blockedCars',
        title: 'Reserverade bilar',
      },
      {
        id: 'mountedOnCar',
        title: 'Monterat på bil',
      },
      {
        id: 'returnStation',
        title: 'Avyttrade bilar',
      },
      {
        id: 'stockInventory',
        title: 'Lagerstatus - Centrallager/Good year',
      },
    ];

    const haveDatePicker = [
      'movedBetweenStations',
      'shippedFromWheelSupplier',
      'recievedAtWarehouse',
      'returnStation',
    ];

    const { currentReport, currentReportsData } = this.state;
    const { submitting } = this.props;

    if (!isAdmin()) {
      return null;
    }

    let showPagination = false;

    return (
      <PageWithSidebar page="orders report" location={this.props.location}>
        <h1> Rapporter</h1>
        <div className="box search-box">
          <div className="box-inner">
            <div className="report">
              {rerportTypes.map((item, index) => {
                return (
                  <input
                    key={index}
                    type="button"
                    name={item.id}
                    id={item.id}
                    className="btn yellow send-order-btn confirm-send-back"
                    value={item.title}
                    data-report-id={item.id}
                    disabled={currentReport === item.id}
                    onClick={(event) => this.showReport(event)}
                  />
                );
              })}
            </div>
          </div>
        </div>
        <div className="print-excel-wrapper">
          {haveDatePicker.includes(this.state.currentReport) && (
            <div>
              <div className="datepicker">
                <DatePicker
                  name="fromDate"
                  placeholderText="Från datum"
                  selected={this.state.fromDate !== '' && this.state.fromDate}
                  onChange={(value) => {
                    this.handleDateChange('fromDate', value);
                  }}
                  dateFormat="yyyy-MM-dd"
                  calendarStartDay={1}
                  locale="sv"
                  autoComplete="off"
                  onChangeRaw={(e) => this.handleDateChangeRaw(e)}
                />
              </div>
              <div className="datepicker">
                <DatePicker
                  name="toDate"
                  placeholderText="Till datum"
                  selected={this.state.toDate !== '' && this.state.toDate}
                  onChange={(value) => {
                    this.handleDateChange('toDate', value);
                  }}
                  dateFormat="yyyy-MM-dd"
                  calendarStartDay={1}
                  locale="sv"
                  autoComplete="off"
                  onChangeRaw={(e) => this.handleDateChangeRaw(e)}
                />
              </div>
            </div>
          )}
          <button
            type="button"
            className="btn yellow print-excel"
            onClick={this.printExcel}
            disabled={currentReportsData.length === 0 ? true : false}
          >
            Hämta Excel-fil
          </button>
        </div>
        <div className=""></div>
        <h2>
          {rerportTypes.map((item) => {
            return currentReport === item.id ? '' + item.title + '' : '';
          })}
        </h2>
        <Loading show={currentReportsData.length === 0 && submitting ? true : false} />

        {currentReportsData && currentReportsData.length > 0 && (
          <ReactTable
            data={currentReportsData}
            loading={submitting}
            loadingText="Laddar..."
            minRows="0"
            pageSize="1000"
            showPaginationTop={false}
            showPaginationBottom={showPagination}
            filterable={false}
            className="search-wheelset-table"
            showPagination={showPagination}
            noDataText="Inga hjul hittades"
            columns={this.getAutoColumns(currentReportsData[0])}
          />
        )}

        {!submitting && currentReportsData.length === 0 && (
          <p> Tyvärr, det finns inga data att visa.</p>
        )}
      </PageWithSidebar>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    submitting: state.reports.submitting,
    reportsData: state.reports.reportsData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    get: (reportType, getPrams) => dispatch(get(reportType, getPrams)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Reports);



// WEBPACK FOOTER //
// ./src/components/Reports/index.js